export interface Country {
  code: string // ISO 3166-1 alpha-2
  name: string
  dialCode: string
  flag: string // Emoji flag
  mask?: string // Phone mask pattern
  placeholder?: string
}

export const COUNTRIES: Country[] = [
  // Brasil (padrão)
  {
    code: 'BR',
    name: 'Brasil',
    dialCode: '+55',
    flag: '🇧🇷',
    mask: '(##) #####-####',
    placeholder: '(11) 98765-4321'
  },

  // América do Norte
  {
    code: 'US',
    name: 'Estados Unidos',
    dialCode: '+1',
    flag: '🇺🇸',
    mask: '(###) ###-####',
    placeholder: '(555) 123-4567'
  },
  {
    code: 'CA',
    name: 'Canadá',
    dialCode: '+1',
    flag: '🇨🇦',
    mask: '(###) ###-####',
    placeholder: '(555) 123-4567'
  },
  {
    code: 'MX',
    name: 'México',
    dialCode: '+52',
    flag: '🇲🇽',
    mask: '## #### ####',
    placeholder: '55 1234 5678'
  },

  // América do Sul
  {
    code: 'AR',
    name: 'Argentina',
    dialCode: '+54',
    flag: '🇦🇷',
    mask: '## #### ####',
    placeholder: '11 1234 5678'
  },
  {
    code: 'CL',
    name: 'Chile',
    dialCode: '+56',
    flag: '🇨🇱',
    mask: '# #### ####',
    placeholder: '9 1234 5678'
  },
  {
    code: 'CO',
    name: 'Colômbia',
    dialCode: '+57',
    flag: '🇨🇴',
    mask: '### ### ####',
    placeholder: '321 123 4567'
  },
  {
    code: 'PE',
    name: 'Peru',
    dialCode: '+51',
    flag: '🇵🇪',
    mask: '### ### ###',
    placeholder: '987 654 321'
  },
  {
    code: 'UY',
    name: 'Uruguai',
    dialCode: '+598',
    flag: '🇺🇾',
    mask: '## ### ###',
    placeholder: '99 123 456'
  },
  {
    code: 'PY',
    name: 'Paraguai',
    dialCode: '+595',
    flag: '🇵🇾',
    mask: '### ######',
    placeholder: '981 123456'
  },

  // Europa
  {
    code: 'GB',
    name: 'Reino Unido',
    dialCode: '+44',
    flag: '🇬🇧',
    mask: '#### ### ####',
    placeholder: '7400 123456'
  },
  {
    code: 'DE',
    name: 'Alemanha',
    dialCode: '+49',
    flag: '🇩🇪',
    mask: '### ########',
    placeholder: '151 12345678'
  },
  {
    code: 'FR',
    name: 'França',
    dialCode: '+33',
    flag: '🇫🇷',
    mask: '# ## ## ## ##',
    placeholder: '6 12 34 56 78'
  },
  {
    code: 'IT',
    name: 'Itália',
    dialCode: '+39',
    flag: '🇮🇹',
    mask: '### ### ####',
    placeholder: '312 345 6789'
  },
  {
    code: 'ES',
    name: 'Espanha',
    dialCode: '+34',
    flag: '🇪🇸',
    mask: '### ## ## ##',
    placeholder: '612 34 56 78'
  },
  {
    code: 'PT',
    name: 'Portugal',
    dialCode: '+351',
    flag: '🇵🇹',
    mask: '### ### ###',
    placeholder: '912 345 678'
  },
  {
    code: 'NL',
    name: 'Holanda',
    dialCode: '+31',
    flag: '🇳🇱',
    mask: '## #### ####',
    placeholder: '6 1234 5678'
  },
  {
    code: 'BE',
    name: 'Bélgica',
    dialCode: '+32',
    flag: '🇧🇪',
    mask: '### ## ## ##',
    placeholder: '470 12 34 56'
  },
  {
    code: 'CH',
    name: 'Suíça',
    dialCode: '+41',
    flag: '🇨🇭',
    mask: '## ### ## ##',
    placeholder: '78 123 45 67'
  },

  // Ásia
  {
    code: 'CN',
    name: 'China',
    dialCode: '+86',
    flag: '🇨🇳',
    mask: '### #### ####',
    placeholder: '138 0013 8000'
  },
  {
    code: 'JP',
    name: 'Japão',
    dialCode: '+81',
    flag: '🇯🇵',
    mask: '## #### ####',
    placeholder: '90 1234 5678'
  },
  {
    code: 'KR',
    name: 'Coreia do Sul',
    dialCode: '+82',
    flag: '🇰🇷',
    mask: '## #### ####',
    placeholder: '10 1234 5678'
  },
  {
    code: 'IN',
    name: 'Índia',
    dialCode: '+91',
    flag: '🇮🇳',
    mask: '##### #####',
    placeholder: '98765 43210'
  },
  {
    code: 'SG',
    name: 'Singapura',
    dialCode: '+65',
    flag: '🇸🇬',
    mask: '#### ####',
    placeholder: '8123 4567'
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    dialCode: '+852',
    flag: '🇭🇰',
    mask: '#### ####',
    placeholder: '5123 4567'
  },
  {
    code: 'AE',
    name: 'Emirados Árabes',
    dialCode: '+971',
    flag: '🇦🇪',
    mask: '## ### ####',
    placeholder: '50 123 4567'
  },

  // Oceania
  {
    code: 'AU',
    name: 'Austrália',
    dialCode: '+61',
    flag: '🇦🇺',
    mask: '### ### ###',
    placeholder: '412 345 678'
  },
  {
    code: 'NZ',
    name: 'Nova Zelândia',
    dialCode: '+64',
    flag: '🇳🇿',
    mask: '## ### ####',
    placeholder: '21 123 4567'
  },

  // América Central
  {
    code: 'PA',
    name: 'Panamá',
    dialCode: '+507',
    flag: '🇵🇦',
    mask: '#### ####',
    placeholder: '6001 2345'
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    dialCode: '+506',
    flag: '🇨🇷',
    mask: '#### ####',
    placeholder: '8312 3456'
  },
]

export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find(c => c.code === code)
}

export function getCountryByDialCode(dialCode: string): Country | undefined {
  return COUNTRIES.find(c => c.dialCode === dialCode)
}

export function searchCountries(query: string): Country[] {
  const searchTerm = query.toLowerCase().trim()

  if (!searchTerm) {
    return COUNTRIES.slice(0, 10)
  }

  return COUNTRIES.filter(country =>
    country.name.toLowerCase().includes(searchTerm) ||
    country.code.toLowerCase().includes(searchTerm) ||
    country.dialCode.includes(searchTerm)
  )
}

// Aplica máscara ao número de telefone
export function formatPhoneNumber(phone: string, mask?: string): string {
  if (!mask) return phone

  const numbers = phone.replace(/\D/g, '')
  let formatted = ''
  let numberIndex = 0

  for (let i = 0; i < mask.length && numberIndex < numbers.length; i++) {
    if (mask[i] === '#') {
      formatted += numbers[numberIndex]
      numberIndex++
    } else {
      formatted += mask[i]
    }
  }

  return formatted
}

// Remove formatação do número
export function unformatPhoneNumber(phone: string): string {
  return phone.replace(/\D/g, '')
}
